
import CreditSection from './CreditSection.view'

export default CreditSection